<template>
  <div>
    <FormItem
      :label="item.label"
      :prop="item.radioType ? item.radioType : item.name"
      :key="index"
      v-for="(item, index) in info"
      v-if="!item.hide"
      :label-width="item.width || 90"
    >
      <div :class="{ unit: item.unit }" @click.stop="selectIndex(item.name)">
        <!-- input -->
        <!--:maxlength="item.type=='text'?26:250"-->
        <Input
          :maxlength="item.maxlength"
          :disabled="item.disabled"
          v-if="
            item.type == 'text' ||
            item.type == 'textarea' ||
            item.type === 'number'
          "
          :type="item.type"
          v-model="rel[item.name]"
          :rows="item.rows ? item.rows : 2"
          :placeholder="
            item.placeholder ? item.placeholder : '请输入' + item.label
          "
          @on-blur="inputNum"
          @on-change="inputChange"
          style="max-width: 600px"
        />
        <!-- Upload -->
        <Upload
          class="vc"
          :show-upload-list="item.type == 'world' ? true : false"
          :default-file-list="defaultList"
          :max-size="20480"
          multiple
          :accept="Accept[item.type]"
          :format="Format[item.type]"
          :class="item.class"
          v-if="
            item.type == 'img' || item.type == 'png' || item.type == 'world'
          "
          type="drag"
          :action="$global.url + '/web/common/upload'"
          :on-success="handleSuccess"
        >
          <img
            v-if="item.type != 'world' && rel[item.name]"
            class="coverImg"
            :src="$global.imgUrl + rel[item.name]"
            alt=""
          />
          <div class="center" v-if="item.type != 'world' && !rel[item.name]">
            <Icon
              type="ios-cloud-upload"
              size="52"
              style="color: #3399ff"
            ></Icon>
            <p>图片上传</p>
          </div>
          <p v-if="item.type == 'world'">
            <Icon type="ios-cloud-upload-outline" />
            文件上传
          </p>
        </Upload>
        <a
          class="vT"
          v-if="item.type == 'world' && rel[item.name]"
          :href="$global.imgUrl + rel[item.name]"
          target="_blank"
        >
          <Icon type="ios-cloud-download-outline" class="s20 mL05" />
          文件下载</a
        >

        <v-upload
          v-if="item.type == 'uploadList'"
          @fun="getImglist"
          :name="item.name"
          :imgList="rel[item.name]"
          :max="item.max"
        ></v-upload>

        <p class="chui2" v-if="item.notes" v-text="item.notes"></p>
        <!-- Checkbox -->
        <Checkbox
          v-if="item.type == 'checkGroup' && item.isAll"
          :disabled="item.disabled"
          :value="
            rel[item.name].length == item.checkAllGroup.length ? true : false
          "
          @click.prevent.native="handleCheckAll(item)"
          >全选
        </Checkbox>
        <CheckboxGroup
          v-if="item.type == 'checkGroup'"
          v-model="rel[item.name]"
          @on-change="selectCheckbox"
        >
          <Checkbox
            v-for="(val, key) in item.checkAllGroup"
            :key="key"
            :label="val.id ? val.id : String(key + 1)"
          >
            <span v-text="val.name ? val.name : val"></span
          ></Checkbox>
        </CheckboxGroup>
        <Checkbox
          v-if="item.type == 'checkbox'"
          v-for="(val, key) in item.checkAllGroup"
          :key="key"
          v-model="rel[val.name]"
          >{{ val.label }}
        </Checkbox>
        <!-- Radio -->
        <div v-if="item.type == 'radio'">
          <RadioGroup v-model="rel[item.name]" @on-change="selectRadio">
            <Radio
              :label="val.id ? val.id : String(key == 0 ? 1 : 0)"
              v-for="(val, key) in item.RadioGroup"
              :key="key"
              :disabled="item.disabled"
            >
              <span v-text="val.name ? val.name : val"></span>
            </Radio>
          </RadioGroup>
          <span class="prize vc" v-if="rel[item.name] == 1 && item.radioType"
            ><i class="vc">价格：</i
            ><Input
              :type="'number'"
              :maxlength="10"
              v-model="rel[item.radioType]"
              class="w1 vc"
            ></Input>
            <i class="vc">￥</i></span
          >
          <span
            v-if="item.invoice"
            v-text="item.invoice"
            style="color: red"
          ></span>
        </div>
        <!---->
        <!-- Radio -->
        <Select
          :transfer="true"
          v-if="item.type == 'select'"
          v-model="rel[item.name]"
          class="w2"
          @on-change="selectOption"
          :disabled="item.disabled"
          style="max-width: 600px"
        >
          <Option
            v-for="(item, i) in item.selectData"
            :value="item.id ? item.id : String(i + 1)"
            :key="i"
            :disabled="item.disabled"
            >{{ item.name }}
          </Option>
        </Select>
        <Select
          :transfer="true"
          v-if="item.type == 'selectNew'"
          v-model="rel[item.name]"
          class="w2"
          @on-change="selectChange"
          :disabled="item.disabled"
        >
          <Option
            v-for="(item, i) in item.selectData"
            :value="item.id ? item.id : String(i + 1)"
            :key="i"
            >{{ item.name }}
          </Option>
        </Select>
        <!-- 时间 -->
        <DatePicker
          :transfer="true"
          v-if="item.type == 'time'"
          type="datetime"
          :format="item.format ? item.format : 'yyyy-MM-dd'"
          :value="rel[item.name]"
          v-model="rel[item.name]"
          @on-change="rel[item.name] = $event"
          placeholder="请选择"
          :editable="false"
        ></DatePicker>
        <!--年-->
        <DatePicker
          :transfer="true"
          v-if="item.type == 'year'"
          type="year"
          :value="rel[item.name]"
          v-model="rel[item.name]"
          @on-change="rel[item.name] = $event"
          placeholder="请选择"
        ></DatePicker>
        <DatePicker
          :transfer="true"
          v-if="item.type == 'timeMonth'"
          type="month"
          format="yyyy-MM"
          :value="rel[item.name]"
          v-model="rel[item.name]"
          @on-change="rel[item.name] = $event"
          placeholder="请选择"
        ></DatePicker>
        <wangeditor
          v-if="item.type == 'editor'"
          :catchData="catchData"
          :type="item.name"
          :rel="rel"
        ></wangeditor>
        <Cascader
          :transfer="true"
          v-if="item.type == 'Cascader'"
          :data="item.data"
          trigger="hover"
          :value="rel[item.name]"
          :clearable="false"
        ></Cascader>
        <slot
          name="city"
          v-if="item.type == 'selectCity' && item.name == 'city'"
        ></slot>
        <slot
          name="job"
          v-if="item.type == 'selectJob' && item.name == 'title'"
        ></slot>
        <slot name="level" v-if="item.type == 'selectLevel'"></slot>

        <slot v-if="item.type == 'action'"></slot>
        <span v-if="item.type == 'view'">
          {{ rel[item.name] }}
        </span>
      </div>
      <span class="unit" v-if="item.unit" v-text="item.unit"></span>
    </FormItem>
  </div>
</template>
<script>
let vm;
import wangeditor from "@/components/wangeditor";
import upload from "@/components/upload";

export default {
  props: ["info", "rel", "commitStatus"],
  data() {
    return {
      vName: "",
      loadingStatus: "",
      defaultList: [],
      Accept: {
        img: ".png,.jpg,.jpeg,.gif",
        png: ".png",
        world: ".docx,.doc,.jpg,.pdf",
        // video:".mp4,.mpeg,.mpg,.avi,.mov,.wmv,.mkv,.flv,.mp3,.wave,.wma"
      },
      Format: {
        img: ["png", "jpg", "jpeg", "gif"],
        png: ["png"],
        world: ["docx", "doc", "jpg", "pdf"],
        // video:['.mp4','.mpeg','.mpg','.avi','.mov','.wmv','.mkv','.flv','.mp3','.wave','.wma']
      },
    };
  },
  mounted() {
    vm = this;
    vm.defaultList = [];
  },
  watch: {
    commitStatus(newName, oldName) {
      vm.$emit("fun", vm.rel);
    },
  },
  methods: {
    // 成功提示
    tip(val, type) {
      if (type) {
        this.$Message.destroy();
        vm.$Message.warning({ content: val });
      } else {
        vm.$Message.success({ content: val });
        vm.cancel();
        vm.pageChange(); //刷新
      }
    },
    getImglist(res, file, fileList) {
      vm.defaultList = [file];
      vm.rel[res.name] = res.url;
    },
    handleSuccess(res, file, fileList) {
      if (res.resultCode == 200) {
        //                  vm.defaultList = [file];
        vm.rel[vm.vName] = res.content.url;
      }
    },
    catchData(html) {},
    selectIndex(value) {
      vm.vName = value;
    },
    selectCheckbox(value) {
      vm.$emit("fun", vm.rel);
    },
    handleCheckAll(item) {
      if (!vm.rel[item.name].length) {
        vm.rel[item.name] = item.checkAllGroup.map((val, index) => {
          val = val.id || String(index + 1);
          return val;
        });
      } else {
        vm.rel[item.name] = [];
      }
    },
    selectRadio(value) {
      if (vm.vName == "isPrePaidFee") {
        vm.rel.prePaidFee = "0.0";
      }
      vm.$emit("fun", vm.rel);
    },
    selectOption(value) {
      vm.$emit("fun", vm.rel);
    },
    selectChange(value) {
      vm.$emit("selectChange", vm.rel);
    },
    inputNum(value) {
      vm.$emit("fun", vm.rel);
    },
    inputChange(value) {
      vm.$emit("inputChange", vm.rel);
    },
  },
  components: {
    wangeditor,
    "v-upload": upload,
  },
};
</script>
<style scoped lang="scss">
.vT {
  line-height: 35px;
  display: inline-block;
  vertical-align: top;
}

.coverImg {
  width: 100%;
  height: 100%;
  /*position: absolute;
        top: 0;
        left: 0;*/
  object-fit: cover;
}

.fengmian {
  /deep/ .ivu-upload-drag {
    height: 260px;
    width: 200px;
  }

  .center {
    margin: 80px auto;
  }
}

.zhang {
  /deep/ .ivu-upload-drag {
    border-radius: 100%;
    height: 200px;
    width: 200px;

    .center {
      margin: 57px auto;
    }
  }
}

.upTitle {
  /deep/ .ivu-upload-drag {
    height: 80px;
    width: 350px;

    .center {
      margin: 0 auto;
    }
  }
}

.file {
  /deep/ .ivu-upload-drag {
    height: 35px;
    width: 130px;
  }
}

.uploadClass {
  /deep/ .ivu-upload-drag {
    width: 150px;
    position: relative;
  }
}
.chui2 {
  color: red;
}
.unit {
  @include vc;
}
</style>



// WEBPACK FOOTER //
// src/components/item1.vue